import { Component, OnInit, Input, Output } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ControlPanel } from '../../../../shared/model';
import { ControlPanelService, ControlPanelServiceDescription } from '../../camtl.service';

@Component({
  selector: 'app-control-panel',
  templateUrl: './control-panel.component.html',
  // styleUrls: ['./control-panel.component.scss']
})
export class ControlPanelComponent implements OnInit {

  constructor(
    // private ControlPanelService: ControlPanelService,
    private ControlPanelServiceDesc: ControlPanelServiceDescription,
    // private FormBuilder: FormBuilder

  ) { }



  isNew: boolean = false;
  editDataItem: ControlPanel;
  editForm = new FormGroup({


    Name: new FormControl(),
    Description: new FormControl(),
    Status: new FormControl(),
    AdditionalInfo: new FormControl(),
    Id: new FormControl(),
    CreatedDate: new FormControl(),
    CreatedBy: new FormControl(),
    ModifiedDate: new FormControl(),
    ModifiedBy: new FormControl(),

  });



  columns: any[] = [
    {
      field: "Name",
      title: "Name",
    },
    {
      field: "Description",
      title: "Description",
    },
    {
      field: "Status",
      title: "Status",
      width: "125",
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    },
    {
      field: "AdditionalInfo",
      title: "Additional Info",

    }
  ]

  template = {

    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: false,
    },
    columns: this.columns,
    service: this.ControlPanelServiceDesc

  }

  formDialog = {
    title: "Control Panel",
    formControls: [
      {
        type: "text",
        name: "Name",
        title: "Name",
        readonly: "never",

      }, {
        type: "text",
        name: "Description",
        title: "Description",
        readonly: "never",

      },
      {
        type: "boolean",
        name: "Status",
        title: "Status",
        readonly: "never",

      },
      {
        type: "text",
        name: "AdditionalInfo",
        title: "Additional Info",

      }
    ],
  }


  public ngOnInit(): void {
    this.ControlPanelServiceDesc.query();
  }

  setModelHandler() {
    this.editDataItem = new ControlPanel();
    console.log(this.formDialog)
  }

}
